const API_CONFIG = {
    isLoggingEnable: false,
    timeout: 20000,
    useDummyData: false,
    unauthorizedErrorCode: 401,
    // api
    HOST: process.env.NEXT_PUBLIC_API_BASE_URL,
    IPAYTOTAL_TRANSACTION_API: process.env.IPAYTOTAL_TRANSACTION_API,
    CHECKOUT_API_URL: process.env.CHECKOUT_API_URL,
    CHECKOUT_SECRET_KEY: process.env.CHECKOUT_SECRET_KEY,
    CHECKOUT_PROCESSING_CHANNEL_ID: process.env.CHECKOUT_PROCESSING_CHANNEL_ID,
    CHECKOUT_PUBLIC_KEY: process.env.NEXT_PUBLIC_CHECKOUT_PUBLIC_KEY,
    NEXT_PUBLIC_CHECKOUT_ENV: process.env.NEXT_PUBLIC_CHECKOUT_ENV as
        | 'sandbox'
        | 'production',
};

export default API_CONFIG;
